import React from 'react';
import { ROUTES } from '@/config/routes';
import HelpCard from './HelpCard';
import { useTranslate } from '@tolgee/react';

// test comment
const AcuteHelpCard: React.FC = () => {
  const { t } = useTranslate();
  return (
    <HelpCard
      title={t('acute_help_card.title.label')}
      titleSize="xl"
      description={t('acute_help_card.description.label')}
      buttonText={t('acute_help_card.button.show_phone.label')}
      buttonVariant="primary"
      buttonBorderColor="white"
      backgroundColor="bg-black"
      textColor="text-white"
      backgroundImage="/img/help.svg"
      link={ROUTES.ACUTE_HELP}
    />
  );
};

export default AcuteHelpCard;
